export enum LabelPointerDirections {
    top = 'top',
    bottom = 'bottom',
    left = 'left',
    right = 'right'
}